const releaseSwarm = document.querySelector('.release-swarm');
const swarm = document.querySelector('.swarm');
const swarmVideo = document.querySelector('.swarm-container__video');
const swarmVideoClose = document.querySelector('.swarm-container__close');
let swarmFilled = false;
let swarmReversing = false;

const startSwarm = () => {
	const fadeIn = () => {
		swarm.style.opacity = 1;
		swarm.style.display = 'block';
		setTimeout(() => { 
			swarmVideoClose.classList.add('swarm-container__close--visible')
		}, 1500);
	}

	fadeIn();
	swarmVideo.play();
	swarmVideo.addEventListener("timeupdate", function(){
    if(this.currentTime >= 3.85 && !swarmFilled && !swarmReversing) {
				this.pause();
				setTimeout(() => {
					swarmFilled = true;
				}, 70);
		}
	swarmVideo.addEventListener("ended", fadeOut);
});
}

const fadeOut = () => {
	const fadeContainer = () => {
		swarm.style.display = 'none';
		swarmVideo.currentTime = 0;
		swarmFilled = false;
		swarmReversing = false;
	}
	swarm.style.opacity = 0;
	swarmVideoClose.classList.remove('swarm-container__close--visible');
	setTimeout(fadeContainer, 500);
}

const stopSwarm = () => {	
	if (swarmFilled) {
		swarmReversing = true;
		swarmFilled = false;
		swarmVideo.play();
	} else {
		swarmVideo.pause();
		fadeOut();
	}
}

swarmVideoClose.addEventListener('click', (event) => {
	event.preventDefault();
	stopSwarm();
});

releaseSwarm.addEventListener('click', (event) => {
	event.preventDefault();
	startSwarm();
})